export default import.meta.ROLLUP_FILE_URL_ffjd20BZfghNiCzGd8o8YQ;